import { useQuery } from "@tanstack/react-query";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { firestore } from "@/base";

interface EmpresaTemplateOption {
  value: string;
  label: string;
  licenciadaId: string;
}

export const useEmpresasForTemplate = (licenciadaId?: string) => {
  return useQuery({
    queryKey: ["empresas-template", licenciadaId],
    queryFn: async (): Promise<EmpresaTemplateOption[]> => {
      if (!licenciadaId) return [];

      const empresasReference = collection(firestore, "licenciadas", licenciadaId, "empresas");
      const q = query(empresasReference, orderBy("razaoSocial"));

      const snapshot = await getDocs(q);

      return snapshot.docs.map((document_) => ({
        value: document_.id,
        label: `${document_.data().razaoSocial} (${document_.data().nomeFantasia || document_.data().razaoSocial})`,
        licenciadaId
      }));
    },
    enabled: !!licenciadaId,
    staleTime: 300_000
  });
};
